import React from 'react';
import { Light as SyntaxHighlighter } from 'react-syntax-highlighter';
import js from 'react-syntax-highlighter/dist/esm/languages/hljs/javascript';
import html from 'react-syntax-highlighter/dist/esm/languages/hljs/xml';

import './tomorrow-night-eighties.less';

SyntaxHighlighter.registerLanguage('javascript', js);
SyntaxHighlighter.registerLanguage('html', html);

const SyntaxHighlight = ({ language, children }) => (
  <SyntaxHighlighter
    language={language}
    useInlineStyles={false}
    wrapLines
  >
    {children}
  </SyntaxHighlighter>
);

export default SyntaxHighlight;
